'use client';
import React, { useEffect, useRef, useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Link from 'next/link';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled
          ? 'rgba(13,13,13,0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(194,24,91,0.15)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <AppLogo
          text="Viral"
          size={32}
          iconName="FilmIcon"
          className="text-chrome-DEFAULT"
        />

        <nav className="hidden md:flex items-center gap-8">
          {['Generate', 'Trends', 'Pricing', 'Creators']?.map((item) => (
            <a
              key={item}
              href={`#${item?.toLowerCase()}`}
              className="text-sm font-medium transition-colors duration-200"
              style={{ color: 'var(--chrome-dim)' }}
              onMouseEnter={e => (e.currentTarget.style.color = 'var(--chrome)')}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--chrome-dim)')}
            >
              {item}
            </a>
          ))}
          <Link
            href="/preview"
            className="text-sm font-medium transition-colors duration-200"
            style={{ color: 'var(--chrome-dim)' }}
            onMouseEnter={e => (e.currentTarget.style.color = 'var(--chrome)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'var(--chrome-dim)')}
          >
            Preview
          </Link>
          <Link
            href="/dashboard"
            className="text-sm font-medium transition-colors duration-200"
            style={{ color: 'var(--chrome-dim)' }}
            onMouseEnter={e => (e.currentTarget.style.color = 'var(--chrome)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'var(--chrome-dim)')}
          >
            Dashboard
          </Link>
        </nav>

        <a
          href="#generate"
          className="btn-ruby px-5 py-2.5 rounded-lg text-sm font-semibold animate-ruby-pulse"
        >
          <span>⚡ Start Free</span>
        </a>
      </div>
    </header>
  );
}